<template>
  <layouts-auth>
    <layouts-auth-width>
      <h1 class="text-title px-2">{{ t('no_video.title') }}</h1>
    </layouts-auth-width>
  </layouts-auth>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'
import LayoutsAuth from '@/layouts/Auth.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'

export default defineComponent({
  components: { LayoutsAuth, LayoutsAuthWidth },
  setup() {
    const { t } = useI18n()

    return {
      t
    }
  },
})
</script>
